import { connect } from 'react-redux';

import ProductionForm from './ProductionForm.js';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const ConnectedProductionForm = connect(
  mapStateToProps,
  null
)(ProductionForm);

export default ConnectedProductionForm;
